//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import VSwatches from 'vue-swatches';
// Import the styles too, typically in App.vue or main.js
import 'vue-swatches/dist/vue-swatches.css';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    props: ['company'],
    data: function data() {
        return {
            infoProjectId: 0,
            infoProjectName: '',
            previewDropzoneImage: {
                url: route('files.store'),
                method: 'POST',
                thumbnailWidth: 300,
                thumbnailHeight: 300,
                maxFiles: 1,
                parallelUploads: 1,
                autoProcessQueue: false,
                addRemoveLinks: true,
                'dictDefaultMessage': 'Legen Sie die Dateien hier ab, um Sie hochzuladen',
                'dictFallbackMessage': 'Ihr Browser unterstützt Drag&Drop Dateiuploads nicht',
                'dictFallbackText': 'Benutzen Sie das Formular um Ihre Dateien hochzuladen',
                'dictFileTooBig': 'Die Datei ist zu groß.',
                'dictInvalidFileType': 'Eine Datei dieses Typs kann nicht hochgeladen werden',
                'dictResponseError': 'Der Server hat ihre Anfrage  abgelehnt',
                'dictCancelUpload': 'Hochladen abbrechen',
                'dictCancelUploadConfirmation': null,
                'dictRemoveFile': 'Datei entfernen',
                'dictMaxFilesExceeded': 'Sie können keine weiteren Dateien mehr hochladen'
            },
            PagedropzoneOptions: {
                url: route('files.store'),
                thumbnailWidth: 150,
                method: 'POST',
                parallelUploads: 1,
                autoProcessQueue: false,
                addRemoveLinks: true,
                'dictDefaultMessage': 'Legen Sie die Dateien hier ab, um Sie hochzuladen',
                'dictFallbackMessage': 'Ihr Browser unterstützt Drag&Drop Dateiuploads nicht',
                'dictFallbackText': 'Benutzen Sie das Formular um Ihre Dateien hochzuladen',
                'dictFileTooBig': 'Die Datei ist zu groß.',
                'dictInvalidFileType': 'Eine Datei dieses Typs kann nicht hochgeladen werden',
                'dictResponseError': 'Der Server hat ihre Anfrage  abgelehnt',
                'dictCancelUpload': 'Hochladen abbrechen',
                'dictCancelUploadConfirmation': null,
                'dictRemoveFile': 'Datei entfernen',
                'dictMaxFilesExceeded': 'Sie können keine weiteren Dateien mehr hochladen'
            }
        };
    },
    mounted: function mounted() {},

    components: {
        FormWizard: FormWizard,
        TabContent: TabContent,
        VSwatches: VSwatches,
        vueDropzone: vue2Dropzone
    },
    methods: {
        previewImageSending: function previewImageSending(file, xhr, formData) {
            formData.append('_token', Laravel.csrfToken);
            formData.append('category', 'info-project-import-preview');
            formData.append('usage', 'preview');
        },
        pageDropzoneSending: function pageDropzoneSending(file, xhr, formData) {
            formData.append('_token', Laravel.csrfToken);
            formData.append('category', 'info-project-import-page');
            formData.append('usage', 'page');
        },
        previewUploadComplete: function previewUploadComplete() {
            console.log('preview upload complete');
            this.$refs.pageDropzone.processQueue();
        },
        pageUploadComplete: function pageUploadComplete() {
            var _this = this;

            console.log('page upload complete');
            console.log("infoproject " + this.infoProjectId);
            axios.post(route('info-projects.import', this.infoProjectId)).then(function () {
                if (_this.company) {
                    window.location.href = route('info-projects.index', {
                        company: _this.company
                    });
                } else {
                    window.location.href = route('info-projects.index');
                }
            });
        },
        onWizardComplete: function onWizardComplete() {
            var _this2 = this;

            swal.fire({
                title: "Bitte warten",
                text: "Ihre Info wird erstellt",

                showConfirmButton: false,
                allowOutsideClick: false
            });

            var storeData = {
                name: this.infoProjectName
            };
            if (this.company) {
                storeData.company = this.company;
            }

            axios.post(route('info-projects.store'), storeData).then(function (response) {
                _this2.infoProjectId = response.data.data.id;
                _this2.$refs.previewImageDropzone.processQueue();
            }).catch(function (reason) {
                swal.fire({
                    title: 'Fehler!',
                    text: "Info konnte nicht erstellt werden",
                    type: 'error'
                });
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/InfoProjectImport.vue
// module id = 51
// module chunks = 0